import { useSavedViewsState } from "../useSavedViewsState";

/**
 * Composition hook for Saved Views State
 * Manages saved views state and configuration
 *
 * Job Duty: Manage saved views state
 */
export function useCompositionSavedViews(
  entityName: string,
  configSavedViews: any[],
  serializeFilters: any,
  applyFilters: any,
  activeViewId: string | null,
  setActiveViewId: any
) {
  const savedViewsState = useSavedViewsState({
    resource: entityName,
    configSavedViews: configSavedViews || [],
    serializeFilters,
    applyFilters,
    activeViewId,
    setActiveViewId,
  });

  return {
    savedViewsState,
  };
}
